import { Color } from '../../../styles/Color';
import { ParkingAvailabilityStatus } from '../domain/models/ParkingAvailabilityStatus';

export function getStatusColor(status: ParkingAvailabilityStatus) {
	if (status === ParkingAvailabilityStatus.Closed) return Color.Error;
	if (status === ParkingAvailabilityStatus.Full) return Color.Error;
	if (status === ParkingAvailabilityStatus.Open) return Color.Success;
	if (status === ParkingAvailabilityStatus.Error) return Color.Neutral;
	return undefined;
}
